import {isServer} from '@adv-mt/mt-utils'

import AdsServicesFactory from '../../ads/Services/factory.js'
import PageMappersFactory from '../Mappers/factory.js'
import {PageRepositoriesFactory} from '../Repositories/factory.js'
import {PageRequestsFactory} from '../Requests/factory.js'
import {GetCurrentUrlService} from './GetCurrentUrlService.js'
import GetLoginUrlWithQueryParamsService from './GetLoginUrlWithQueryParamsService.js'
import GetPageNamePageService from './GetPageNamePageService.js'
import {GetRemoteUrlService} from './GetRemoteUrlService.js'
import GetUrlService from './GetUrlService.js'

export default class PageServicesFactory {
  static getPageNamePageService = ({config}) => {
    return new GetPageNamePageService({
      mapper: PageMappersFactory.fromQueryParamsToTargetPageValueObjectPageMapper({
        config
      })
    })
  }

  static getUrlService = ({config}) => {
    return new GetUrlService({
      config,
      getRemoteUrlService: PageServicesFactory.getRemoteUrlService({config}),
      mapper: PageMappersFactory.urlMapper({config})
    })
  }

  static getRemoteUrlService = ({config}) =>
    new GetRemoteUrlService({
      requestFactory: PageRequestsFactory.getRemoteUrlRequest,
      repository: PageRepositoriesFactory.hTTPPageRepository({config})
    })

  static getLoginUrlWithQueryParamsService = ({config}) => {
    return new GetLoginUrlWithQueryParamsService({
      config,
      getUrlService: PageServicesFactory.getUrlService({config}),
      getSearchUrlService: AdsServicesFactory.getSearchUrlAdsService({config})
    })
  }

  static getCurrentUrlService = () =>
    new GetCurrentUrlService({
      repository: isServer
        ? PageRepositoriesFactory.emptyPageRepository()
        : PageRepositoriesFactory.clientPageRepository()
    })
}
